import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-1.5 py-0.5 text-[11px] font-medium w-fit whitespace-nowrap shrink-0 gap-1",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        outline: "text-muted-foreground",
        /** 待办 / 进行中 —— 橙色，提示要看但不是错误。 */
        warning: "border-transparent bg-warning/15 text-warning",
        /** 完成 / 到账 —— 绿色。 */
        success: "border-transparent bg-success/15 text-success",
        /** 失败 / 已退 —— 红色，别滥用。 */
        destructive: "border-transparent bg-destructive/10 text-destructive",
        brand: "border-transparent bg-brand-50 text-brand-700",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";
  return <Comp className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
